
import { ChevronDownIcon, SettingsIcon } from 'vue-feather-icons'
import { savePreset } from '../../fc/Dal/OptionsRepo'
export default {
  components: { ChevronDownIcon, SettingsIcon },
  props: {
    inPage: {
      type: Boolean,
      required: false,
      default: false
    },
    // eslint-disable-next-line vue/require-prop-types
    list: {
      required: false,
      default: false
    },
    // eslint-disable-next-line vue/require-prop-types
    uid: {
      required: true
    },
    // eslint-disable-next-line vue/require-prop-types
    slug: {
      required: true
    },
    previewTemplate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    presetName: '',
    selectedPreset: '',
    saveLabel: '',
    selectionBtnLabel: '',
    error: ''
  }),
  computed: {
    presetsList () {
      const presets = [...this.$store.state.presetsList]
      return presets
        .reduce((acc, cur) => {
          const allowed = cur.operation === this.getOperation()

          acc.push({
            name: cur.name + ' -- ' + '/' + cur.operation.split('/').slice(-1).pop() + (allowed ? '' : ' (Not applicable)'),
            allowed,
            id: cur._id
          })
          return acc
        }, []
        )
        .sort(function (x, y) {
          return (x.allowed === y.allowed) ? 0 : x.allowed ? -1 : 1
        })
    },
    freeUser () {
      return this.$store.state.subscription.free
    },
    loggedIn () {
      return this.$auth ? this.$auth.Token : false
    },
    info () { return this.$store.state.info },
    advancedOptionListResponsiveView () { return this.$store.state.store.advancedOptionListResponsiveView }
  },
  watch: {
    list () {
      this.getData()
    }
  },
  created () {
    this.saveLabel = this.$t('save')
    this.selectionBtnLabel = this.$t('load')
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.error = ''
      if (this.list) {
        await this.$store.dispatch('getPresets', this.$auth.Token)
        if (!this.presetsList.length) {
          this.error = this.$t('no_preset_msg')
        }
      }
    },
    getOperation () {
      // consider the slug as operation instead of (operation+slug)
      return this.slug
    },
    async savePreset () {
      if (!this.validatePresetName()) { return }
      this.error = ''
      this.saveLabel = this.$t('saving') + '...'
      const options = this.$store.state.advancedSetting.userData.allSelection[this.uid]
      const name = this.presetName
      const operation = this.getOperation()

      const postData = {
        name,
        operation,
        config: JSON.stringify(options)
      }
      try {
        await savePreset(this.$auth.Token, postData)
        this.saveLabel = this.$t('saved') + '!'
        this.$store.dispatch('getPresets', this.$auth.Token)
      } catch (e) {
        this.error = this.$t('error_saving_preset')
      }

      setTimeout(() => {
        this.saveLabel = this.$t('save')
      }, 3000)
    },
    applyFromPreset () {
      if (!this.selectedPreset) {
        this.error = this.$t('select_preset_msg')
        return
      }
      this.error = ''
      const preset = this.$store.state.presetsList.find(p => p._id === this.selectedPreset)

      if (preset && preset.config) {
        this.selectionBtnLabel = this.$t('loaded') + '!'
        const options = JSON.parse(preset.config)
        this.$store.commit('advancedSetting/setAllSelection', {
          id: this.uid,
          options
        })
        if (this.info.operation === 'crop') {
          this.$bus.$emit('CropPresetApply', options)
        }
        this.scrollToTop()
        setTimeout(() => { this.selectionBtnLabel = this.$t('load') }, 1000)
      }
    },
    onPresetChange () {
      this.error = ''
      this.selectionBtnLabel = this.$t('load')
    },
    validatePresetName () {
      // Trim the name
      this.presetName = this.presetName.trim()
      // Check if the name is empty
      if (this.presetName.length === 0) {
        this.error = this.$t('preset_name_empty')
        return false
      }
      // check if preset name exists
      const preset = this.$store.state.presetsList.find(p => p.name.toLowerCase() === this.presetName.toLowerCase())
      if (preset) {
        this.error = this.$t('preset_name_exists')
        return false
      }
      // preset name should only contain alphanumeric characters, spaces, and dashes
      const regex = /^[^<>%$]*$/g
      if (!regex.test(this.presetName)) {
        this.error = this.$t('preset_name_character')
        return false
      }
      return true
    },
    scrollToTop () {
      setTimeout(() => {
        const presetBox = document.getElementById('panel-0')
        if (presetBox) {
          presetBox.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
        }
      }, 200)
    }
  }
}
